module.exports = __webpack_public_path__ + "img/date-blue.9d3be193.png";